import axios from "../../lib/axios";
import { IFilter } from "../../types/filters.types";
import checkIsLocalhost from "../../utils/checkIsLocalhost";

const baseUrl = process.env.REACT_APP_API_BASE_URL || "/";

export const getOrderHistoryDsdData = (filters: IFilter): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getOrderHistoryDsd(MViewInput: {DSDVendor: ${filters.dsdVendor}, RetailDivision: ${filters.retailDivision}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}, CIC: "${filters.cic}"})
    {
      storeOrdersDsd{ orderNumber orderQuantity statusTypeCd orderDate scheduledDeliveryDate }
      errors { errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/mview`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw
  );
};

export const getOrderHistoryDsdTotalQuantity = (
  filters: IFilter
): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getOrderHistoryTotalDsd(MViewInput: {DSDVendor: ${filters.dsdVendor}, RetailDivision: ${filters.retailDivision}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}, CIC: "${filters.cic}"})
    {
      storeOrderTotalQtyDsd
      errors { errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/mview`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw
  );
};
